<template>
  <VContainer
    grid-list-xl
    text-xs-center
  >
    <VForm v-model="valid">
      <VTextField
        v-model="username"
        :label="$t('form.username')"
        required
      />
      <VTextField
        v-model="email"
        :label="$t('form.email')"
        required
      />
      <RouterLink :to="{ name: 'ResetPassword' }">
        <VBtn color="primary">
          {{ $t('form.password_reset') }}
        </VBtn>
      </RouterLink>
    </VForm>
  </VContainer>
</template>

<script>
import UserApi from '@/api/user';
import { mapGetters } from 'vuex';

export default {
  name: 'Profile',
  data() {
    return {
      valid: true,
    };
  },
  computed: {
    ...mapGetters({
      personal: 'user/personal',
    }),
    username() {
      return this.personal.username;
    },
    email() {
      return this.personal.email;
    },
  },
  async created() {
    if (!this.personal.username) {
      const profile = await UserApi.getProfile();
      this.$store.dispatch('user/setUser', profile);
    }
  },
};
</script>
